import React, { useEffect, useState } from "react";
import {
  Avatar,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import WordCloudWrapper from "../components/WordCloudWrapper";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../components/PageHeader";
import { SentimentGauge } from "../components/SentimentGauge";
import { getAllSites } from "../api/newsspecs/sites/SitesSpecsAPI";
import { WordBarElement } from "../components/WordBarElement";
import { getHomepageData } from "../api/statistics/homepage/HomepageStatisticsAPI";
import NumberInputBasic from "../components/NumberInput";
import $ from "jquery";

function TrendingPage() {
  const [time, setTime] = useState({ hour: 12, day: 28 });
  const [words, setWords] = useState([]);
  const [sentiment, setSentiment] = useState(null);
  const [oldKeywords, setOldKeywords] = useState([]);
  const [sites, setSites] = useState([]);
  const [activeSites, setActiveSites] = useState([]);
  const [negativeKeywords, setNegativeKeywords] = useState([]);
  const [positiveKeywords, setPositiveKeywords] = useState([]);
  const { t } = useTranslation(["account", "common", "sidebar", "site"]);

  useEffect(() => {
    getAllSites()
      .then((res) => {
        setSites(res);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    getHomepageData(time.hour)
      .then((res) => {
        setWords(res["popularKeywords"]);
        if (res["oldPopularKeywords"] > 1) {
          setOldKeywords(JSON.parse(res["oldPopularKeywords"][1]["keywords"]));
        } else
          setOldKeywords(JSON.parse(res["oldPopularKeywords"][0]["keywords"]));
        setSentiment(res["overallSentiment"]);
        setPositiveKeywords(res["positiveKeywords"]);
        setNegativeKeywords(res["negativeKeywords"]);
        setActiveSites(res["activeSites"]);
      })
      .catch(() => {});
  }, [time.hour]);

  var oldRanks = oldKeywords.map((oldKeyword, index) => {
    return {
      rank: index + 1,
      keyword: (oldKeyword["token"] as any).toString().toLowerCase(),
    };
  });

  var highestPositive =
    positiveKeywords.length > 0 ? positiveKeywords[0]["points"] : 1;

  var positiveKeywordsList = positiveKeywords.slice(0, 3).map((keyword) => {
    var barLength = highestPositive
      ? (keyword["points"] / highestPositive) * 100
      : 1;
    return (
      <WordBarElement
        word={keyword["token"]}
        scaledNumber={barLength}
        icon={<StarPurple500Icon color="warning" />}
      />
    );
  });

  var highestNegative =
    negativeKeywords.length > 0 ? negativeKeywords[0]["points"] : 1;

  var negativeKeywordsList = negativeKeywords.slice(0, 2).map((keyword) => {
    var barLength = highestNegative
      ? (keyword["points"] / highestNegative) * 100
      : 1;
    return (
      <WordBarElement
        word={keyword["token"]}
        scaledNumber={barLength}
        color="error"
        icon={<WhatshotIcon color="error" />}
      />
    );
  });
  var activeSitesList = activeSites.slice(0, 5).map((site) => {
    var siteData = sites.filter((a) => {
      return a["name"] == site["site"];
    });
    var siteIcon =
      siteData.length > 0
        ? "https://www.google.com/s2/favicons?domain=" +
          siteData[0]["domain"] +
          "/favicon.ico"
        : "";
    return (
      <ListItem
        className="minor-scale-up-hover grey-hover"
        sx={{ paddingLeft: "12px", paddingRight: "12px" }}
      >
        <ListItemAvatar>
          <Avatar alt={site["site"]} src={siteIcon} style={{width: "32px", height: "32px"}}/>
        </ListItemAvatar>
        <Link
          href={siteData[0] ? siteData[0]["domain"] : "https://trendz.vn"}
          underline="none"
          target={"_blank"}
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            flexDirection: "row",
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
        >
          <ListItemText
            primary={site["site"]}
            primaryTypographyProps={{
              fontSize: "20px",
              fontWeight: 500,
              align: "left",
            }}
            secondary={site["count"] + " " + t("common:articles")}
          />
        </Link>
      </ListItem>
    );
  });

  return (
    <Grid container spacing={0}>
      <PageHeader
        text={t("sidebar:keyword") + " HOT " + t("common:within")}
        textAfterSupplement={t("common:recent_hours")}
        supplement={
          <NumberInputBasic
            id="hour-input"
            value={time.hour}
            onChange={(event, val) => {
              setTime({
                hour: parseInt(val.toString()) || 1,
                day: time.day,
              });
            }}
            onKey={() => {
              setTime({
                hour: parseInt($("#hour-input").val().toString()) || 1,
                day: time.day,
              });
            }}
          ></NumberInputBasic>
        }
      />

      <Grid container xs={12}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={7}>
          <WordCloudWrapper
            words={words}
            time={time.hour}
            oldRanks={oldRanks}
          />
        </Grid>
        <Grid item xs={0.25}></Grid>
        <Grid
          item
          xs={3.25}
          className="white slide-from-right grid-border"
          sx={{ marginTop: "10px" }}
        >
          <Typography
            variant="h6"
            align="left"
            marginLeft={"15px"}
            marginTop={"10px"}
            fontWeight={500}
            marginBottom={"10px"}
          >
            {t("common:overall_sentiment") + " " + t("common:today")}
          </Typography>
          <SentimentGauge sentiment={sentiment} />
          <Typography
            variant="h6"
            align="left"
            marginLeft={"15px"}
            marginTop={"10px"}
            fontWeight={500}
            marginBottom={"5px"}
          >
            {t("keyword:most_positive_keywords") + " " + t("common:today")}
          </Typography>
          <List
            sx={{ display: "flex", flexDirection: "column", paddingTop: "0px" }}
          >
            {positiveKeywordsList}
          </List>
          <Typography
            variant="h6"
            align="left"
            marginLeft={"15px"}
            marginTop={"5px"}
            fontWeight={500}
            marginBottom={"5px"}
          >
            {t("keyword:most_negative_keywords") + " " + t("common:today")}
          </Typography>
          <List
            sx={{ display: "flex", flexDirection: "column", paddingTop: "0px" }}
          >
            {negativeKeywordsList}
          </List>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
      <Grid container xs={12} marginTop={"20px"} className="slide-from-bottom ">
        <Grid item xs={0.75}></Grid>
        <Grid item xs={10.5} className="white grid-border">
          <Typography
            variant="h6"
            align="left"
            marginLeft={"15px"}
            marginTop={"10px"}
            fontWeight={500}
          >
            {t("site:most_active_sites")}
          </Typography>
          <List
            sx={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "0px",
              paddingLeft: "20px",
            }}
          >
            {activeSitesList}
          </List>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
    </Grid>
  );
}
export default TrendingPage;
